import React, { useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { Navigation } from '@/components/Navigation';
import { useAuthStore } from './stores/authStore';

// Lazy load pages for code splitting
const Home = lazy(() => import('@/pages/Home').then(m => ({ default: m.Home })));
const Blog = lazy(() => import('@/pages/Blog').then(m => ({ default: m.Blog })));
const PostDetail = lazy(() => import('@/pages/PostDetail').then(m => ({ default: m.PostDetail })));
const Search = lazy(() => import('@/pages/Search').then(m => ({ default: m.Search })));
const About = lazy(() => import('@/pages/About').then(m => ({ default: m.About })));
const AdminWrite = lazy(() => import('@/pages/AdminWrite').then(m => ({ default: m.AdminWrite })));
const AdminLogin = lazy(() => import('@/pages/AdminLogin').then(m => ({ default: m.AdminLogin })));
const AdminDashboard = lazy(() => import('@/pages/AdminDashboard').then(m => ({ default: m.AdminDashboard })));

// React Query 클라이언트 생성
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5분
      gcTime: 10 * 60 * 1000, // 10분 (cacheTime 대신 gcTime 사용)
      retry: 1,
    },
  },
});

function App() {
  const { verifyToken } = useAuthStore();

  // 앱 시작 시 토큰 검증
  useEffect(() => {
    verifyToken();
  }, [verifyToken]);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-amber-50 via-stone-50 to-orange-50 dark:from-gray-900 dark:via-gray-800 dark:to-blue-900">
          <Navigation />
          <Suspense fallback={
            <div className="flex items-center justify-center min-h-screen">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 dark:border-white"></div>
            </div>
          }>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/posts/:slug" element={<PostDetail />} />
              <Route path="/search" element={<Search />} />
              <Route path="/about" element={<About />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/write" element={<AdminWrite />} />
              <Route path="/admin/write/:id" element={<AdminWrite />} />
            </Routes>
          </Suspense>
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App;